import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import Badge from '../Badge.js';
// Which creditor a hook is pinned to; null is a tenant wide hook. Only
// meaningful in the caseworker app — the creditor portal shows one creditor.
const HookCreditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const creditorsLoadable = useAllCreditors(props.creditorId === null);
    const creditor = h.hasData(creditorsLoadable)
        ? creditorsLoadable.data.find((candidateCreditor) => candidateCreditor.creditorId === props.creditorId)
        : null;
    if (props.creditorId === null) {
        return (React.createElement(Badge, { theme: THEME.COLOR_GREY }, lang.webhookSettings.allCreditors));
    }
    return (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, title: props.creditorId }, creditor?.name ?? props.creditorId));
};
export default HookCreditor;
//# sourceMappingURL=HookCreditor.js.map